import { Paper, Button, IconButton, Card, Typography, Avatar, Grid } from "@mui/material";
import React, { useState } from "react";
import { Draggable } from "react-beautiful-dnd";
import { makeStyles } from '@mui/styles';
import { campaingService } from "@/service/services/Campaing.service";
import { ModalChangeDetailCampaign } from "@/components/common/Modal/ModalChangeDetailCampaing";
import { cotizacionService } from "@/service/services/Cotizacion.service";


const TrelloCard = ({ card, index, pipelines,CambioDataTable,updateCard,list }) => {
  const classes = useStyle();
  const [open, setOpen] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [detailSelect, setDetailSelect] = useState<any>([]);
  const [nombreVendedor, setNombreVendedor] = useState<any>(card.nombre_usuario);


  const RecuperarChangeDetail = async(data) => {

   if(data.idvendedor!=='') {

   const resp = await cotizacionService.cotizacionesChangeUser(data.folio,data.idvendedor)

   if(resp.data){
      //getDetalleCampaing();
      //pipelines()
      CambioDataTable(resp.data);
      updateCard(resp.data,list.id)
      setOpenModal(false)
      setNombreVendedor(data.nombrevendedor)
   }}
};

  return (
    <>
      <Draggable draggableId={card.idcotizacion} index={index}>
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.dragHandleProps}
            {...provided.draggableProps}
          >
            <Paper
              className={classes.trelloCard}
            >
               <Grid container justifyContent='space-between'>
                     <Grid item xs={9}>
                        <Typography> {card.razon_social
                        }</Typography>
                     </Grid>
                     <Grid item>
                       <Avatar sizes='small' sx={{background:'#1976D2'}}
                       onClick={()=>{setOpenModal(true)
                        setDetailSelect(card)
                     }}>
                        {nombreVendedor==null?'':nombreVendedor.charAt(0)}</Avatar>
                     </Grid>
               </Grid>

              {/* {card.nombre_usuario} */}

            </Paper>
          </div>
        )}
      </Draggable>
      <ModalChangeDetailCampaign
         open={openModal}
         setOpen={setOpenModal}
         detailSelect={detailSelect}
         setDetailSelect={setDetailSelect}
         RecuperarData={RecuperarChangeDetail}
         source='trello'
         />
    </>
  );
};

export default TrelloCard;

const useStyle = makeStyles((theme) => ({
  trelloCard: {
    padding: 10,
    margin: 10,
  },
}));
